<ng-container [formGroup]="form">
  <harp-input
    *ngFor="let option of options"
    [inputConfig]="getCheckboxConfig(inputConfig, option)"
  ></harp-input>
</ng-container>
